<template lang="">
    <section class="bg-white py-4 px-4 sm:px-2 rounded-2xl">
        <div class="flex w-full justify-between">
            <h1 class="text-xl text-primary">Olá, <span class="font-bold">{{ name }}</span></h1>
            <div class="flex items-center justify-center gap-x-4">
                <!-- <h1 class="text-primary">Regional <span class="font-bold">{{ region }}</span></h1> -->
                <!-- <a v-if="dashboardPermission" @click="showModalUnderMaintance = true"><Button class="py-1 sm:hidden block">Dashboard</Button></a> -->
                <a v-if="dashboardPermission" :href="`https://powerbi.digi.ag/NestleVenca?pwd=96bz95bdd7d3a5791f4084d223f0c897&id=${this.participantId}`" target="_blank"><Button class="py-1 sm:hidden block">Dashboard</Button></a>
                <h1 v-if="displayRegionDataPermission" class="text-primary">Regional <span class="font-bold">{{ region }}</span></h1>
                <h1 v-else class="text-primary flex gap-x-2 flex-wrap">Sub-regional <span class="font-bold">{{ subRegion }}</span></h1>
            </div>
        </div>
        <div v-if="dashboardPermission" class="w-full hidden sm:block mt-4">
            <!-- <a @click="showModalUnderMaintance = true"><Button class="py-1">Dashboard</Button></a> -->
            <a :href="`https://powerbi.digi.ag/NestleVenca?pwd=96bz95bdd7d3a5791f4084d223f0c897&id=${this.participantId}`" target="_blank"><Button class="py-1">Dashboard</Button></a>
        </div>
    </section>
    <transition>
        <div
            v-if="showModalUnderMaintance"
            class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
        >
            <div
                class="bg-white border-[1px] border-gray-200 rounded-[4px] max-w-[348px] w-full px-4 py-4"
            >
                <button class="float-right" @click="showModalUnderMaintance = false">
                    <Icon name="Fechar" />
                </button>
                <h1 class="text-[20px] font-bold text-primary text-center">
                    Aviso
                </h1>
                <p class="mt-2.5">
                    Função em manutenção.
                </p>
            </div>
        </div>
    </transition>
</template>
<script>
import Button from '@/Components/Button.vue'
import Icon from "@/Components/UI/Icons/Icon.vue";
export default {
    components: {
        Button,
        Icon,
    },
    props: {
        name: String,
        region: String,
        subRegion: String
    },
    data() {
        return {
            showModalUnderMaintance: false,
        }
    },
    computed: {
        jobTitle() {
            return this.$page.props.auth.user.participant.jobTitle
        },
        participantType() {
            return this.$page.props.auth.user.participant.type
        },
        isMerchanParticipant() {
            return this.participantType == "M"
        },
        dashboardPermission() {
            if(this.isMerchanParticipant) {
                return ['GERENTE', 'LIDER', 'LÍDER'].includes(this.jobTitle);
            } else {
                return false;
            }
        },
        displayRegionDataPermission() {
            if(this.isMerchanParticipant) {
                return ['GERENTE'].includes(this.jobTitle);
            } else {
                return false;
            }
        },
        participantId() {
            return this.$page.props.auth.user.participant.id
        },
    }
}
</script>
